<form
  [formGroup]="patientForm"
  (ngSubmit)="onSubmit()"
  style="margin-top: 10px"
>
  <div class="row g-4">
    <div class="col-md-6">
      <div class="card bg-darker p-8 h-100">
        <div class="card-title text-white mb-4 d-flex align-items-center">
          <i class="fs-5 me-2 fas fa-user"></i>
          <h5 class="mb-0">{{ "patientCreate.personalInfo" | translate }}</h5>
        </div>
        <div class="border-bottom border-warning mb-4"></div>

        <div class="row g-3" formGroupName="personalInfo">
          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.firstName" | translate }}
              <span class="text-danger">*</span>
            </label>
            <input
              type="text"
              class="form-control bg-dark border-secondary text-light"
              [placeholder]="'patientCreate.form.firstName' | translate"
              formControlName="firstName"
              [class.is-invalid]="
                patientForm.get('personalInfo.firstName')?.invalid &&
                patientForm.get('personalInfo.firstName')?.touched
              "
            />
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('personalInfo.firstName')?.invalid &&
                patientForm.get('personalInfo.firstName')?.touched
              "
            >
              <span
                *ngIf="
                  patientForm
                    .get('personalInfo.firstName')
                    ?.hasError('required')
                "
              >
                {{ "patientCreate.validation.required" | translate }}
              </span>
              <span
                *ngIf="
                  patientForm
                    .get('personalInfo.firstName')
                    ?.hasError('minlength')
                "
              >
                {{ "patientCreate.validation.minLength" | translate }}
              </span>
              <span
                *ngIf="
                  patientForm
                    .get('personalInfo.firstName')
                    ?.hasError('maxlength')
                "
              >
                {{ "patientCreate.validation.maxLength" | translate }}
              </span>
              <span
                *ngIf="
                  patientForm.get('personalInfo.firstName')?.hasError('pattern')
                "
              >
                {{ "patientCreate.validation.patternLetters" | translate }}
              </span>
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.lastName" | translate }}
              <span class="text-danger">*</span>
            </label>
            <input
              type="text"
              class="form-control bg-dark border-secondary text-light"
              [placeholder]="'patientCreate.form.lastName' | translate"
              formControlName="lastName"
              [class.is-invalid]="
                patientForm.get('personalInfo.lastName')?.invalid &&
                patientForm.get('personalInfo.lastName')?.touched
              "
            />
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('personalInfo.lastName')?.invalid &&
                patientForm.get('personalInfo.lastName')?.touched
              "
            >
              <span
                *ngIf="
                  patientForm.get('personalInfo.lastName')?.hasError('required')
                "
              >
                {{ "patientCreate.validation.required" | translate }}
              </span>
              <span
                *ngIf="
                  patientForm
                    .get('personalInfo.lastName')
                    ?.hasError('minlength')
                "
              >
                {{ "patientCreate.validation.minLength" | translate }}
              </span>
              <span
                *ngIf="
                  patientForm
                    .get('personalInfo.lastName')
                    ?.hasError('maxlength')
                "
              >
                {{ "patientCreate.validation.maxLength" | translate }}
              </span>
              <span
                *ngIf="
                  patientForm.get('personalInfo.lastName')?.hasError('pattern')
                "
              >
                {{ "patientCreate.validation.patternLetters" | translate }}
              </span>
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.pid" | translate }}
              <span class="text-danger">*</span>
            </label>
            <input
              type="text"
              class="form-control bg-dark border-secondary text-light"
              placeholder="(e.g., 123456)"
              formControlName="pid"
              [class.is-invalid]="
                patientForm.get('personalInfo.pid')?.invalid &&
                patientForm.get('personalInfo.pid')?.touched
              "
              (blur)="onPidBlur()"
            />
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('personalInfo.pid')?.invalid &&
                patientForm.get('personalInfo.pid')?.touched
              "
            >
              <div
                *ngIf="
                  patientForm.get('personalInfo.pid')?.hasError('required')
                "
              >
                {{ "patientCreate.validation.required" | translate }}
              </div>
              <div
                *ngIf="
                  patientForm.get('personalInfo.pid')?.hasError('minlength')
                "
              >
                {{ "patientCreate.validation.pidMinLength" | translate }}
              </div>
              <div
                *ngIf="
                  patientForm.get('personalInfo.pid')?.hasError('maxlength')
                "
              >
                {{ "patientCreate.validation.pidMaxLength" | translate }}
              </div>
              <div
                *ngIf="patientForm.get('personalInfo.pid')?.hasError('pattern')"
              >
                {{ "patientCreate.validation.pidPattern" | translate }}
              </div>
              <div
                *ngIf="
                  patientForm.get('personalInfo.pid')?.hasError('patientExists')
                "
              >
                {{ "patientCreate.warning.patientExists" | translate }}
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.dob" | translate }}
              <span class="text-danger">*</span>
            </label>
            <div class="input-group">
              <input
                type="date"
                class="form-control bg-dark border-secondary text-light"
                formControlName="dob"
                (input)="onDateInput($event)"
                [max]="todayDate"
                min="1900-01-01"
                [class.is-invalid]="
                  patientForm.get('personalInfo.dob')?.invalid &&
                  patientForm.get('personalInfo.dob')?.touched
                "
              />
            </div>
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('personalInfo.dob')?.invalid &&
                patientForm.get('personalInfo.dob')?.touched
              "
            >
              <span
                *ngIf="
                  patientForm.get('personalInfo.dob')?.hasError('required')
                "
              >
                {{ "patientCreate.validation.required" | translate }}
              </span>
              <span
                *ngIf="
                  patientForm.get('personalInfo.dob')?.hasError('futureDate')
                "
              >
                {{ "patientCreate.validation.futureDate" | translate }}
              </span>
              <span
                *ngIf="patientForm.get('personalInfo.dob')?.hasError('oldDate')"
              >
                {{ "patientCreate.validation.oldDate" | translate }}
              </span>
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.gender" | translate }}
              <span class="text-danger">*</span>
            </label>
            <app-select
              formControlName="gender"
              [items]="genders"
              bindLabel="name"
              bindValue="id"
              [clearable]="true"
              [multiple]="false"
              [placeholder]="'patientCreate.form.chooseGender' | translate"
            ></app-select>
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('personalInfo.gender')?.invalid &&
                patientForm.get('personalInfo.gender')?.touched
              "
            >
              {{ "patientCreate.validation.required" | translate }}
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.phone" | translate }}
              <span class="text-danger">*</span>
            </label>
            <ngx-intl-tel-input
              appPhoneInput
              [cssClass]="'form-control'"
              [enableAutoCountrySelect]="true"
              [enablePlaceholder]="true"
              [searchCountryFlag]="true"
              [searchCountryField]="[
                SearchCountryField.Iso2,
                SearchCountryField.Name,
              ]"
              [selectFirstCountry]="false"
              [selectedCountryISO]="defaultPatientCountry"
              [maxLength]="15"
              [phoneValidation]="true"
              [separateDialCode]="true"
              name="phone"
              formControlName="phoneNumber"
            >
            </ngx-intl-tel-input>
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('personalInfo.phoneNumber')?.invalid &&
                patientForm.get('personalInfo.phoneNumber')?.touched
              "
            >
              {{ "patientCreate.validation.required" | translate }}
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.email" | translate }}
              <span class="text-danger">*</span>
            </label>
            <input
              type="email"
              class="form-control bg-dark border-secondary text-light"
              placeholder="(e.g., name@example.com)"
              formControlName="email"
              [class.is-invalid]="
                patientForm.get('personalInfo.email')?.invalid &&
                patientForm.get('personalInfo.email')?.touched
              "
            />
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('personalInfo.email')?.invalid &&
                patientForm.get('personalInfo.email')?.touched
              "
            >
              <span
                *ngIf="
                  patientForm.get('personalInfo.email')?.hasError('required')
                "
              >
                {{ "patientCreate.validation.required" | translate }}
              </span>
              <span
                *ngIf="patientForm.get('personalInfo.email')?.hasError('email')"
              >
                {{ "patientCreate.validation.invalidEmail" | translate }}
              </span>
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.occupation" | translate }}
              <span class="text-danger">*</span>
            </label>
            <app-select
              formControlName="occupation"
              [items]="occupations"
              bindLabel="name"
              bindValue="id"
              [clearable]="true"
              [multiple]="false"
              [placeholder]="'patientCreate.form.occupation' | translate"
            ></app-select>
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('personalInfo.occupation')?.invalid &&
                patientForm.get('personalInfo.occupation')?.touched
              "
            >
              <span
                *ngIf="
                  patientForm
                    .get('personalInfo.occupation')
                    ?.hasError('required')
                "
              >
                {{ "patientCreate.validation.required" | translate }}
              </span>
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.nationality" | translate }}
              <span class="text-danger">*</span>
            </label>
            <app-select
              formControlName="nationality"
              [items]="nationalities"
              bindLabel="name"
              bindValue="id"
              [clearable]="true"
              [multiple]="false"
              [placeholder]="'patientCreate.form.nationality' | translate"
            ></app-select>
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('personalInfo.nationality')?.invalid &&
                patientForm.get('personalInfo.nationality')?.touched
              "
            >
              <span
                *ngIf="
                  patientForm
                    .get('personalInfo.nationality')
                    ?.hasError('required')
                "
              >
                {{ "patientCreate.validation.required" | translate }}
              </span>
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.maritalStatus" | translate }}
            </label>
            <app-select
              formControlName="maritalStatus"
              [items]="maritalStatuses"
              bindLabel="name"
              bindValue="id"
              [clearable]="true"
              [multiple]="false"
              [placeholder]="'patientCreate.form.maritalStatus' | translate"
            ></app-select>
          </div>

          <div class="col-md-6" *ngIf="organizations.length > 0">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.organization" | translate }}
              <span class="text-danger">*</span>
            </label>
            <app-select
              formControlName="organizationId"
              [items]="organizations"
              bindLabel="name"
              bindValue="id"
              [clearable]="true"
              [multiple]="false"
              [placeholder]="'patientCreate.form.organization' | translate"
              (change)="onOrganizationChange($event)"
            ></app-select>
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('personalInfo.organizationId')?.invalid &&
                patientForm.get('personalInfo.organizationId')?.touched
              "
            >
              <span
                *ngIf="
                  patientForm
                    .get('personalInfo.organizationId')
                    ?.hasError('required')
                "
              >
                {{ "patientCreate.validation.required" | translate }}
              </span>
            </div>
          </div>

          <!-- Facilities Dropdown -->
          <div class="col-md-6" *ngIf="isSystemAdmin">
            <label class="form-label text-light fs-12 mb-1">
              {{ "organization.facility" | translate }}
              <span class="text-danger">*</span>
            </label>
            <app-select
              formControlName="facilityId"
              [items]="facilities"
              bindLabel="name"
              bindValue="id"
              [clearable]="true"
              [multiple]="false"
              [placeholder]="'organization.facility' | translate"
            ></app-select>
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('personalInfo.facilityId')?.invalid &&
                patientForm.get('personalInfo.facilityId')?.touched
              "
            >
              <span
                *ngIf="
                  patientForm
                    .get('personalInfo.facilityId')
                    ?.hasError('required')
                "
              >
                {{ "patientCreate.validation.required" | translate }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="card bg-darker p-8 h-100">
        <div class="card-title text-white mb-4 d-flex align-items-center">
          <i class="fs-5 me-2 fas fa-map-marker-alt"></i>
          <h5 class="mb-0">{{ "patientCreate.addressInfo" | translate }}</h5>
        </div>
        <div class="border-bottom border-warning mb-4"></div>

        <div class="row g-3" formGroupName="addressInfo">
          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.country" | translate }}
              <span class="text-danger">*</span>
            </label>
            <app-select
              formControlName="country"
              [items]="countries"
              bindLabel="name"
              bindValue="id"
              [clearable]="true"
              [multiple]="false"
              [placeholder]="'patientCreate.form.country' | translate"
              (change)="onCountryChange($event)"
            ></app-select>
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('addressInfo.country')?.invalid &&
                patientForm.get('addressInfo.country')?.touched
              "
            >
              {{ "patientCreate.validation.required" | translate }}
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.city" | translate }}
              <span class="text-danger" *ngIf="cities.length > 0">*</span>
            </label>
            <app-select
              formControlName="city"
              [items]="cities"
              bindLabel="name"
              bindValue="id"
              [clearable]="true"
              [multiple]="false"
              [placeholder]="'patientCreate.form.city' | translate"
              (change)="onCityChange($event)"
            ></app-select>
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('addressInfo.city')?.invalid &&
                patientForm.get('addressInfo.city')?.touched
              "
            >
              <span
                *ngIf="
                  patientForm.get('addressInfo.city')?.hasError('required')
                "
              >
                {{ "patientCreate.validation.required" | translate }}
              </span>
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.district" | translate }}
              <span class="text-danger" *ngIf="districts.length > 0">*</span>
            </label>
            <app-select
              formControlName="district"
              [items]="districts"
              bindLabel="name"
              bindValue="id"
              [clearable]="true"
              [multiple]="false"
              [placeholder]="'patientCreate.form.district' | translate"
            ></app-select>
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('addressInfo.district')?.invalid &&
                patientForm.get('addressInfo.district')?.touched
              "
            >
              <span
                *ngIf="
                  patientForm.get('addressInfo.district')?.hasError('required')
                "
              >
                {{ "patientCreate.validation.required" | translate }}
              </span>
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.neighborhood" | translate }}
            </label>
            <input
              type="text"
              class="form-control bg-dark border-secondary text-light"
              [placeholder]="'patientCreate.form.neighborhood' | translate"
              formControlName="neighborhood"
              [class.is-invalid]="
                patientForm.get('addressInfo.neighborhood')?.invalid &&
                patientForm.get('addressInfo.neighborhood')?.touched
              "
            />
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('addressInfo.neighborhood')?.invalid &&
                patientForm.get('addressInfo.neighborhood')?.touched
              "
            >
              <span
                *ngIf="
                  patientForm
                    .get('addressInfo.neighborhood')
                    ?.hasError('maxlength')
                "
              >
                {{ "patientCreate.validation.maxLength100" | translate }}
              </span>
              <span
                *ngIf="
                  patientForm
                    .get('addressInfo.neighborhood')
                    ?.hasError('pattern')
                "
              >
                {{ "patientCreate.validation.patternLetters" | translate }}
              </span>
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.street" | translate }}
            </label>
            <input
              type="text"
              class="form-control bg-dark border-secondary text-light"
              [placeholder]="'patientCreate.form.street' | translate"
              formControlName="street"
              [class.is-invalid]="
                patientForm.get('addressInfo.street')?.invalid &&
                patientForm.get('addressInfo.street')?.touched
              "
            />
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('addressInfo.street')?.invalid &&
                patientForm.get('addressInfo.street')?.touched
              "
            >
              <span
                *ngIf="
                  patientForm.get('addressInfo.street')?.hasError('maxlength')
                "
              >
                {{ "patientCreate.validation.maxLength100" | translate }}
              </span>
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.buildingNo" | translate }}
            </label>
            <input
              type="text"
              class="form-control bg-dark border-secondary text-light"
              [placeholder]="'patientCreate.form.buildingNo' | translate"
              formControlName="buildingNo"
              [class.is-invalid]="
                patientForm.get('addressInfo.buildingNo')?.invalid &&
                patientForm.get('addressInfo.buildingNo')?.touched
              "
            />
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('addressInfo.buildingNo')?.invalid &&
                patientForm.get('addressInfo.buildingNo')?.touched
              "
            >
              <span
                *ngIf="
                  patientForm
                    .get('addressInfo.buildingNo')
                    ?.hasError('maxlength')
                "
              >
                {{ "patientCreate.validation.maxLength10" | translate }}
              </span>
              <span
                *ngIf="
                  patientForm.get('addressInfo.buildingNo')?.hasError('pattern')
                "
              >
                {{ "patientCreate.validation.patternAlphanumeric" | translate }}
              </span>
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.apartmentNo" | translate }}
            </label>
            <input
              type="text"
              class="form-control bg-dark border-secondary text-light"
              [placeholder]="'patientCreate.form.apartmentNo' | translate"
              formControlName="apartmentNo"
              [class.is-invalid]="
                patientForm.get('addressInfo.apartmentNo')?.invalid &&
                patientForm.get('addressInfo.apartmentNo')?.touched
              "
            />
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('addressInfo.apartmentNo')?.invalid &&
                patientForm.get('addressInfo.apartmentNo')?.touched
              "
            >
              <span
                *ngIf="
                  patientForm
                    .get('addressInfo.apartmentNo')
                    ?.hasError('maxlength')
                "
              >
                {{ "patientCreate.validation.maxLength10" | translate }}
              </span>
              <span
                *ngIf="
                  patientForm
                    .get('addressInfo.apartmentNo')
                    ?.hasError('pattern')
                "
              >
                {{ "patientCreate.validation.patternNumber" | translate }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="card bg-darker p-5">
        <div class="card-title text-white mb-4 d-flex align-items-center">
          <i class="fs-5 me-2 fas fa-phone-alt"></i>
          <h5 class="mb-0">
            {{ "patientCreate.emergencyContact" | translate }}
          </h5>
        </div>
        <div class="border-bottom border-warning mb-4"></div>

        <div class="row g-3" formGroupName="emergencyContact">
          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.emergencyFirstName" | translate }}
            </label>
            <input
              type="text"
              class="form-control bg-dark border-secondary text-light"
              [placeholder]="
                'patientCreate.form.emergencyFirstName' | translate
              "
              formControlName="firstName"
              [class.is-invalid]="
                patientForm.get('emergencyContact.firstName')?.invalid &&
                patientForm.get('emergencyContact.firstName')?.touched
              "
            />
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('emergencyContact.firstName')?.invalid &&
                patientForm.get('emergencyContact.firstName')?.touched
              "
            >
              <span
                *ngIf="
                  patientForm
                    .get('emergencyContact.firstName')
                    ?.hasError('minlength')
                "
              >
                {{ "patientCreate.validation.minLength" | translate }}
              </span>
              <span
                *ngIf="
                  patientForm
                    .get('emergencyContact.firstName')
                    ?.hasError('maxlength')
                "
              >
                {{ "patientCreate.validation.maxLength" | translate }}
              </span>
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.emergencyLastName" | translate }}
            </label>
            <input
              type="text"
              class="form-control bg-dark border-secondary text-light"
              [placeholder]="'patientCreate.form.emergencyLastName' | translate"
              formControlName="lastName"
              [class.is-invalid]="
                patientForm.get('emergencyContact.lastName')?.invalid &&
                patientForm.get('emergencyContact.lastName')?.touched
              "
            />
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('emergencyContact.lastName')?.invalid &&
                patientForm.get('emergencyContact.lastName')?.touched
              "
            >
              <span
                *ngIf="
                  patientForm
                    .get('emergencyContact.lastName')
                    ?.hasError('minlength')
                "
              >
                {{ "patientCreate.validation.minLength" | translate }}
              </span>
              <span
                *ngIf="
                  patientForm
                    .get('emergencyContact.lastName')
                    ?.hasError('maxlength')
                "
              >
                {{ "patientCreate.validation.maxLength" | translate }}
              </span>
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.emergencyPhone" | translate }}
            </label>
            <ngx-intl-tel-input
              appPhoneInput
              [cssClass]="'form-control'"
              [enableAutoCountrySelect]="true"
              [enablePlaceholder]="true"
              [searchCountryFlag]="true"
              [searchCountryField]="[
                SearchCountryField.Iso2,
                SearchCountryField.Name,
              ]"
              [selectFirstCountry]="false"
              [selectedCountryISO]="defaultEmergencyContactCountry"
              [maxLength]="15"
              [phoneValidation]="true"
              [separateDialCode]="true"
              name="emergencyPhone"
              formControlName="phoneNumber"
            >
            </ngx-intl-tel-input>
          </div>

          <div class="col-md-6">
            <label class="form-label text-light fs-12 mb-1">
              {{ "patientCreate.form.emergencyEmail" | translate }}
            </label>
            <input
              type="email"
              class="form-control bg-dark border-secondary text-light"
              placeholder="(e.g., name@example.com)"
              formControlName="email"
              [class.is-invalid]="
                patientForm.get('emergencyContact.email')?.invalid &&
                patientForm.get('emergencyContact.email')?.touched
              "
            />
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('emergencyContact.email')?.invalid &&
                patientForm.get('emergencyContact.email')?.touched
              "
            >
              <span
                *ngIf="
                  patientForm.get('emergencyContact.email')?.hasError('email')
                "
              >
                {{ "patientCreate.validation.invalidEmail" | translate }}
              </span>
            </div>
          </div>

          <div class="col-12">
            <label class="form-label text-light fs-12 mb-3 d-block">
              {{ "patientCreate.form.emergencyRelationship" | translate }}
            </label>
            <div class="d-flex gap-3">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="relationship"
                  id="family"
                  [value]="1"
                  formControlName="relationship"
                />
                <label class="form-check-label text-light fs-12" for="family">
                  {{ "patientCreate.form.familyMember" | translate }}
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="relationship"
                  id="spouse"
                  [value]="2"
                  formControlName="relationship"
                />
                <label class="form-check-label text-light fs-12" for="spouse">
                  {{ "patientCreate.form.spouse" | translate }}
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="relationship"
                  id="friend"
                  [value]="3"
                  formControlName="relationship"
                />
                <label class="form-check-label text-light fs-12" for="friend">
                  {{ "patientCreate.form.friend" | translate }}
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="relationship"
                  id="other"
                  [value]="4"
                  formControlName="relationship"
                />
                <label class="form-check-label text-light fs-12" for="other">
                  {{ "patientCreate.form.other" | translate }}
                </label>
              </div>
            </div>
            <div
              class="text-danger fs-12 mt-1"
              *ngIf="
                patientForm.get('emergencyContact.relationship')?.invalid &&
                patientForm.get('emergencyContact.relationship')?.touched
              "
            >
              <span
                *ngIf="
                  patientForm
                    .get('emergencyContact.relationship')
                    ?.hasError('required')
                "
              >
                {{ "patientCreate.validation.required" | translate }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 d-flex justify-content-end mt-4">
      <button type="submit" class="btn btn-warning text-dark fw-bold px-4 py-2">
        {{ "patientCreate.form.next" | translate }}
        <i class="fas fa-arrow-right ms-2"></i>
      </button>
    </div>
  </div>
</form>
